import { GridMenuProps } from "@mui/x-data-grid";
import { MuiComponentThemeDefinition } from "../utils";

export const MuiGridMenu: MuiComponentThemeDefinition<string, GridMenuProps> = {
  props: {},
  override: () => ({
    root: {},
  }),
};
